export default (store) => {
  store.dispatch('account/changeNotification'); // app.UpdateAccountInfo()
};
